import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login");
      return;
    }

    api.post("/auth/session", { session_id: sessionId })
      .then(() => {
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-secondary font-display text-2xl">Autenticazione in corso…</div>
    </div>
  );
}
